import auth from './auth'
import errors from './errors'
import settings from './settings'
import global from './global'

export default {
  global,
  settings,
  errors,
  auth
}
